import { getActivity, getWorkflow } from './workflow-api';

export type WorksheetService =
  | 'coding-queue'
  | 'worksheet'
  | 'codesets'
  | 'downcode'
  | 'lostrevenue'
  | 'codingconfig'
  | 'codernotes'
  | 'worksheettracking'
  | 'visittracking'
  | 'codereviewquestion'
  | 'productivity'
  | 'cachemanager'
  | 'auditbatchquery'
  | 'ncnbreason'
  | 'providersendback'
  | 'em-calculator';

export type WorksheetAction =
  | 'searchcodingqueue'
  | 'addCPT'
  | 'checkout'
  | 'checkconnection'
  | 'saveworksheet'
  | 'transition'
  | 'transitiontocoded'
  | 'transitiontounassigned'
  | 'transitiontostashed'
  | 'getdxorprocedure'
  | 'getdxorprocedures'
  | 'getprocedure'
  | 'getmodifier'
  | 'getcodebycodeandtype'
  | 'addcodernote'
  | 'deletecodernote'
  | 'acknowledgecodernote'
  | 'getcodernotes'
  | 'addstickynote'
  | 'deletestickynote'
  | 'textsearch'
  | 'savedowncode'
  | 'getdowncodes'
  | 'deletedowncode'
  | 'updatedowncode'
  | 'savelostrevenue'
  | 'getlostrevenue'
  | 'deletelostrevenue'
  | 'updatelostrevenue'
  | 'updatetrackingcode'
  | 'addtrackingcode'
  | 'gettrackingcodes'
  | 'deletetrackingcode'
  | 'updatetrackingcode'
  | 'getlocationdepartmentconfig'
  | 'getcodingconfig'
  | 'getemcalculatordepartmentconfig'
  | 'calculateemfromtime'
  | 'calculateemfromelements'
  | 'adddisposition'
  | 'addarrivalmode'
  | 'addinjury'
  | 'getTracking'
  | 'processedits'
  | 'addsendback'
  | 'deletesendback'
  | 'updatesendback'
  | 'getsendbacks'
  | 'acknowledgeAlert'
  | 'overrideAlert'
  | 'saveandvalidateworksheet'
  | 'setattending'
  | 'getnext'
  | 'addquestion'
  | 'updatequestion'
  | 'deletequestion'
  | 'getcoderproductivity'
  | 'getusers'
  | 'getndclist'
  | 'getauditbatches'
  | 'getauditreviewlist'
  | 'deletearrivalmode'
  | 'deletedisposition'
  | 'addreason'
  | 'deletereason'
  | 'updatereason'
  | 'getreasons'
  | 'deleteinjury'
  | 'em-calculator'
  | 'getmodifiers'
  | 'addtclsendback'
  | string;

type WorksheetWorkflow = string;

export interface WorksheetMessage<T = any> {
  service: WorksheetService;
  action: WorksheetAction;
  workflow?: WorksheetWorkflow;
  activity?: string;
  data: T;
}

export function worksheetMessage<T = any>(
  data: T,
  action: WorksheetAction,
  service: WorksheetService = 'worksheet',
  workflow?: WorksheetWorkflow,
  activity?: WorksheetWorkflow
): WorksheetMessage {
  workflow = workflow ? workflow : workflow === null ? undefined : getWorkflow();
  activity = activity || getActivity();
  return { data, action, service, workflow, activity };
}

export interface WorksheetResult<T = any> {
  service?: WorksheetService;
  action?: WorksheetAction;
  workflow?: WorksheetWorkflow;
  success?: boolean;
  result?: T;
  errors?: string[];
  alerts?: any[];
}
